import axiosService from "../services/axiosService";
const axios = axiosService.getInstance()

export default {
  actions: {
    async authLogin(context, data) {
      return await axios.post(`/api/Account/Auth/Login`, data)
      .then(response => {
        console.log(response)
        if(response.data.result.code == 0){
          context.commit('saveUser', response.data.user)
          context.commit('allLoad')
          axiosService.updateAccessToken(response.data.accessToken)
          context.commit('saveAccessToken', response.data.accessToken)
          context.commit('saveRefreshToken', response.data.refreshToken)
          localStorage.setItem('refresh_token', response.data.refreshToken)
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch(err => {
        throw err
      })
    },
    async createUserByAgregator(context, body) {
      return await axios.post(`/api/Account/Create`, body)
      .then((response) => {
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
    async editUser(context, body) {
      return await axios.post(`/api/Account/EditUser`, body)
      .then((response) => {
        console.log(response)
        if(response.data.result.code == 0){
          context.commit('saveUser', response.data.user)
          context.commit('allLoad')
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
    async loginUserByToken(context) {
      return await axios.get(`/api/Account/Auth`)
      .then((response) => {
        console.log(response)
        if(response.data.result.code == 0){
          context.commit('saveDateTime', new Date(response.data.dateTime))
          context.commit('saveUser', response.data.user)
          context.commit('allLoad')
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
  },
  state: {
    user: null,
    dateTime: null
  },
  mutations: {
    saveDateTime(state, data){
      if(state.dateTime == null){
        state.dateTime = data
        setInterval(() => {
          const dt = new Date(state.dateTime)
          dt.setSeconds(state.dateTime.getSeconds() + 1);
          state.dateTime = dt
        }, 1000)
      }
    },
    saveUser(state, user){
      state.user = user
    }
  },
  getters: {
    getUser(state){
      return state.user
    },
    getDateTime(state){
      return state.dateTime
    }
  }
}